import React, { memo, useCallback, useEffect, useRef } from "react";
import {
   Modal,
   ModalOverlay,
   ModalContent,
   ModalBody,
   Box,
   Image,
   Text,
   useToast,
   Flex,
   Spacer,
   Link,
} from "@chakra-ui/react";
import WalletConnectProvider from "@walletconnect/web3-provider";
import Bus from "@/event";
import {
   EVENT_WALLET_CONNECTED,
   EVENT_WALLET_CONNECT_ERROR,
   EVENT_WALLET_MODAL_CLOSE,
   EVENT_WALLET_SWITCH_CHAINE,
} from "@/event/constants";
const WalletSelectModal = memo(({ isOpen, onClose }) => {
   const toast = useToast();
   var metaMaskProviderRef = useRef();
   var coinBaseProviderRef = useRef();
   var currentProviderRef = useRef();
   var currentAddressesRef = useRef();
   async function selectWallet(str) {
      try {
         if (str === "metamask") {
            if (typeof window.ethereum !== "undefined") {
               currentProviderRef.current = metaMaskProviderRef.current ? metaMaskProviderRef.current : window.ethereum;
               currentAddressesRef.current = await currentProviderRef.current.request({
                  method: "eth_requestAccounts",
               });
            } else {
               toast({
                  title: "MetaMask is not installed!",
                  status: "error",
               });
               onClose();
               return;
            }
         } else if (str === "walletconnect") {
            currentProviderRef.current = new WalletConnectProvider({
               infuraId: process.env.REACT_APP_INFURA_ID,
            });
            currentAddressesRef.current = await currentProviderRef.current.enable();
         } else if (str === "coinbase") {
            if (typeof window.ethereum !== "undefined") {
               currentProviderRef.current = coinBaseProviderRef.current ? coinBaseProviderRef.current : window.ethereum;
               currentAddressesRef.current = await currentProviderRef.current.request({
                  method: "eth_requestAccounts",
               });
            } else {
               toast({
                  title: "CoinBase is not installed!",
                  status: "error",
               });
               onClose();
               return;
            }
         }
         if (currentAddressesRef.current != null && currentAddressesRef.current.length > 0) {
            initListener();
            onClose();
            Bus.emit(EVENT_WALLET_CONNECTED, currentProviderRef.current, currentAddressesRef.current[0]);
         }
      } catch (err) {
         Bus.emit(EVENT_WALLET_CONNECT_ERROR, err.message);
      }
   }
   const chainChangedParameters = useCallback((chainID) => {
      if (currentProviderRef.current && currentAddressesRef.current && currentAddressesRef.current.length > 0) {
         Bus.emit(EVENT_WALLET_SWITCH_CHAINE, chainID, currentProviderRef.current, currentAddressesRef.current[0]);
      }
   }, []);
   function initListener() {
      currentProviderRef.current.removeListener("chainChanged", chainChangedParameters);
      currentProviderRef.current.on("chainChanged", chainChangedParameters);
   }
   const initProvider = useCallback(() => {
      if (typeof window.ethereum !== "undefined" && window.ethereum.providers?.length > 0) {
         metaMaskProviderRef.current = window.ethereum.providers.find((provider) => provider.isMetaMask);
         coinBaseProviderRef.current = window.ethereum.providers.find((provider) => !provider.isMetaMask);
      }
   }, []);
   useEffect(() => {
      initProvider();
   }, [initProvider]);

   return (
      <Modal isOpen={isOpen} onClose={onClose} onEsc={false} closeOnOverlayClick={false} isCentered w={"450px"}>
         <ModalOverlay />
         <ModalContent borderRadius={"12px"}>
            <Flex display={"flex"} alignItems="center" justifyContent={"center"} mt={"40px"}>
               <Image
                  cursor={"pointer"}
                  src={process.env.REACT_APP_PUBLIC_URL + "iconfont/arrow_back_icon.svg"}
                  onClick={(e) => {
                     Bus.emit(EVENT_WALLET_MODAL_CLOSE);
                     onClose();
                  }}
                  marginRight="20px"></Image>
               <Text variant={"26_black_bold"}>Choose your wallet</Text>
            </Flex>
            <Text variant="14_black" w={"360px"} mx={"auto"} textAlign="center" mt={"18px"}>
               By connecting your wallet, you agree to our{" "}
               <Text
                  as="span"
                  variant={"14_black_bold"}
                  _hover={{ color: "green.500" }}
                  cursor="pointer">
                  <Link
                     href={"/doc/termsofservice"}
                     isExternal
                     _focus={{ boxShadow: "none" }}
                     style={{ textDecoration: "none" }}>
                     Terms of Service
                  </Link>
               </Text>
               {" "}and our{" "}
               <Text
                  as="span"
                  variant={"14_black_bold"}
                  _hover={{ color: "green.500" }}
                  cursor="pointer">
                  <Link
                     href={"/doc/privacy"}
                     isExternal
                     _focus={{ boxShadow: "none" }}
                     style={{ textDecoration: "none" }}>
                     Privacy Policy
                  </Link>
               </Text>
               .
            </Text>
            <ModalBody>
               <Box
                  onClick={(e) => selectWallet("metamask")}
                  padding="0 20px"
                  display="flex"
                  alignItems="center"
                  height="64px"
                  marginTop="20px"
                  cursor="pointer"
                  _hover={{ bg: "#F7F7F7", borderRadius: "10px" }}>
                  <Image src={process.env.REACT_APP_PUBLIC_URL + "images/mm.png"} width="24px" height="24px"></Image>
                  <Text ml={"20px"} variant={'18_lblack_bold'}>
                     MetaMask
                  </Text>
                  <Spacer />
                  <Image
                     boxSize={"14px"}
                     src={process.env.REACT_APP_PUBLIC_URL + "iconfont/arrow_right_normal_icon.svg"}
                     onClick={onClose}></Image>
               </Box>
               <Box
                  onClick={(e) => selectWallet("walletconnect")}
                  padding="0 20px"
                  display="flex"
                  alignItems="center"
                  height="64px"
                  marginTop="20px"
                  cursor="pointer"
                  _hover={{ bg: "#F7F7F7", borderRadius: "10px" }}>
                  <Image src={process.env.REACT_APP_PUBLIC_URL + "images/qqw.jpeg"} width="24px" height="24px"></Image>
                  <Text ml={"20px"} variant={'18_lblack_bold'}>
                     WalletConnect
                  </Text>
                  <Spacer />
                  <Image
                     boxSize={"14px"}
                     src={process.env.REACT_APP_PUBLIC_URL + "iconfont/arrow_right_normal_icon.svg"}
                     onClick={onClose}></Image>
               </Box>
               <Box
                  onClick={(e) => selectWallet("coinbase")}
                  padding="0 20px"
                  display="flex"
                  alignItems="center"
                  height="64px"
                  margin="20px 0"
                  cursor="pointer"
                  _hover={{ bg: "#F7F7F7", borderRadius: "10px" }}>
                  <Image src={process.env.REACT_APP_PUBLIC_URL + "images/cbw.png"} width="24px" height="24px"></Image>
                  <Text ml={"20px"} variant={'18_lblack_bold'}>
                     Coinbase Wallet
                  </Text>
                  <Spacer />
                  <Image
                     boxSize={"14px"}
                     src={process.env.REACT_APP_PUBLIC_URL + "iconfont/arrow_right_normal_icon.svg"}
                     onClick={onClose}></Image>
               </Box>
            </ModalBody>
         </ModalContent>
      </Modal>
   );
});
export default WalletSelectModal;
